import { AxiosResponse } from 'axios'

import {
	IRetail,
	IRetailCreateDTO,
	TRetailUpdateDTO,
} from 'shared/interfaces/retail'
import { IRetailTotalsResponse } from 'shared/interfaces/retail.responses'
import { IUnit } from 'shared/interfaces/units'
import axiosInstance from '../../shared/services/axiosInstance'

export async function fetchRetailTotals(
	userId: string,
): Promise<IRetailTotalsResponse[]> {
	try {
		const response: AxiosResponse = await axiosInstance.get(`/retail/totals`)

		return response.data.content
	} catch (error) {
		return []
	}
}

export async function fetchAllRetail(): Promise<IUnit[]> {
	try {
		const response: AxiosResponse = await axiosInstance.get(`/retail`)

		return response.data.content
	} catch (error) {
		return []
	}
}

export async function createRetail(retail: IRetailCreateDTO) {
	const response: AxiosResponse = await axiosInstance.post(`/retail/`, retail)

	return response.data.content
}

export async function editRetail(retailId: string, retail: TRetailUpdateDTO) {
	const response: AxiosResponse = await axiosInstance.patch(
		`/retail/${retailId}`,
		retail,
	)

	return response.data.content
}

export async function deleteRetail(retailId: string) {
	const response: AxiosResponse = await axiosInstance.delete(
		`/retail/` + retailId,
	)

	return response.data
}

export async function getHigaEcommerce(externalApiReferenceID: string) {
	const response: AxiosResponse = await axiosInstance.get(
		`/retail/get-higa-ecommerce/${externalApiReferenceID}`,
	)

	return response.data
}
